import React from 'react';
import classNames from 'classnames';
import createCell from '../createCell';

const BodyCell = ({
  className,
  children,
  style,
  contentClassName,
  ...props
}) => (
  <div className={className} style={style}>
    <div
      className={classNames('Table-cellContent text-wrap', contentClassName)}
      {...props}
    >
      {children}
    </div>
  </div>
);

export default createCell(BodyCell);
